var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }